import React, { useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntity } from './device-sensor.reducer';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import DoNotShowInProduction from 'app/shared/components/do-not-show-in-production/do-not-show-in-production.component';

export const DeviceSensorDetail = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, []);

  const deviceSensorEntity = useAppSelector(state => state.deviceSensor.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="deviceSensorDetailsHeading">
          <Translate contentKey="fleetSenseApp.deviceSensor.detail.title">DeviceSensor</Translate>
        </h2>
        <dl className="jh-entity-details">
          <DoNotShowInProduction>
            <dt>
              <span id="id">
                <Translate contentKey="global.field.id">ID</Translate>
              </span>
            </dt>
            <dd>{deviceSensorEntity.id}</dd>
          </DoNotShowInProduction>
          <dt>
            <span id="hardwareKey">
              <Translate contentKey="fleetSenseApp.deviceSensor.hardwareKey">Hardware Key</Translate>
            </span>
          </dt>
          <dd>{deviceSensorEntity.hardwareKey}</dd>
          <dt>
            <Translate contentKey="fleetSenseApp.deviceSensor.sensor">Sensor</Translate>
          </dt>
          <dd>{deviceSensorEntity.sensor ? deviceSensorEntity.sensor.description : ''}</dd>
          <dt>
            <Translate contentKey="fleetSenseApp.deviceSensor.sensorHardware">Sensor Hardware</Translate>
          </dt>
          <dd>{deviceSensorEntity.sensorHardware ? deviceSensorEntity.sensorHardware.manufacturer : ''}</dd>
          <dt>
            <Translate contentKey="fleetSenseApp.deviceSensor.deviceTruckImplement">Device Truck Implement</Translate>
          </dt>
          <dd>{deviceSensorEntity.deviceTruckImplement ? deviceSensorEntity.deviceTruckImplement.serial : ''}</dd>
        </dl>
        <Button tag={Link} to="/device-sensor" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/device-sensor/${deviceSensorEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default DeviceSensorDetail;
